import React, { MouseEventHandler } from 'react';
import classNames from 'classnames';
import { slugify, kbygPaths } from '@surfline/web-common';
import WavetrakLink from '../WavetrakLink';

import { SpotReportData } from '../../types/spot';

import styles from './CamListLink.module.scss';

const { spotReportPath } = kbygPaths;

const getClassName = (active: boolean, disable: boolean) =>
  classNames({
    [styles.camListLink]: true,
    [styles.camListLinkActive]: active,
    [styles.camListLinkDisabled]: disable,
    'cam-list-link': true,
  });

interface Props {
  spot: SpotReportData;
  children: React.ReactNode;
  onMouseEnter?: MouseEventHandler<HTMLAnchorElement>;
  onMouseLeave?: MouseEventHandler<HTMLAnchorElement>;
  active?: boolean;
  disabled?: boolean;
  segmentEvent: (...args: any) => void;
}

const CamListLink: React.FC<Props> = ({
  spot,
  children,
  onMouseEnter = undefined,
  onMouseLeave = undefined,
  active = false,
  disabled = false,
  segmentEvent = () => {},
}) => (
  <WavetrakLink
    href={spotReportPath(slugify(spot.name), spot._id)}
    className={getClassName(active, disabled)}
    data-testid="camListLink"
    onClick={segmentEvent}
    onMouseEnter={onMouseEnter}
    onMouseLeave={onMouseLeave}
    title={`${spot.name} Surf Report & Forecast`}
  >
    {children}
  </WavetrakLink>
);

export default CamListLink;
